/**
 *  ----------------------------------------------------------------
 *  Copyright © Backbase B.V.
 *  ----------------------------------------------------------------
 *  Author : Backbase R&D - Amsterdam - New York
 *  Filename : main.js
 *  Description: ${widget.description}
 *  ----------------------------------------------------------------
 */

define(function (require, exports, module) {
    'use strict';

    module.name = 'widget-login';

    var base = require('base');
    var core = require('core');
    var ui = require('ui');
    var components = require('module-metro-components');
    var auth = require('module-metro-users');
    var iceMe = require('feature-ice-me');
    var tulip = require('module-metro-tulip');
    var common = require('module-metro-common');

    var deps = [
        core.name,
        ui.name,
        auth.name,
        iceMe.name,
        components.name,
        tulip.name,
        common.name,
    ];

    // @ngInject
    function run(lpWidget, metToggle) {
        // Module is Bootstrapped
        metToggle.setConfig({
            toggleEndpoint: lpWidget.getPreference('toggleEndpoint'),
        });

    }

    module.exports = base.createModule(module.name, deps)
        .controller(require('./controllers'))
        .directive(require('./directives/focusNextInputDirective'))
        .directive(require('./directives/onlyNumberInputDirective'))
        .service(require('./services/securityCodeService'))
        .service(require('./services/idle-timeout'))
        .run(run);
});



// WEBPACK FOOTER //
// ./scripts/main.js